import PortableText from "components/PortableText"
import PortableTitle from "components/shared/PortableTitle"
import { parseBackground, useSizing } from "lib/helpers"
import { urlForImage } from "lib/sanity.image"
import { MediaText4 } from "schemas"
import { Container, Grid, styled, VStack } from "styled-system/jsx"

type Props = MediaText4

function MediaText4({
  contentTitle,
  body,
  image,
  position,
  hideMediaMobile,
  style,

  sizingTop,
  sizingBottom,
  backgroundColor1,
  backgroundColor2,
  backgroundStyle,
}: Props) {
  return (
    <styled.div
      style={
        {
          background: parseBackground(
            backgroundColor1,
            backgroundColor2,
            backgroundStyle
          ),

          "--pt": useSizing(sizingTop) || "64px",
          "--pb": useSizing(sizingBottom) || "64px",
        } as React.CSSProperties
      }
      css={{
        // height: "60vh",
        pt: "var(--pt)",
        pb: "var(--pb)",
        bgColor: "rgba(136, 156, 255, 0.29)",
        overflow: "hidden",
        color: "#000A3A",
      }}>
      <Container>
        <Grid columns={{ base: 1, lg: 2 }} gap="44px">
          <styled.div
            position="relative"
            order={{ base: "1", lg: position === "left" ? "-1" : "1" }}>
            {image?.asset && (
              <styled.img
                hideBelow={hideMediaMobile && "md"}
                alt={image.alt || ""}
                src={urlForImage(image).url()}
                css={{
                  position: "relative",
                  zIndex: 1,
                }}
              />
            )}
          </styled.div>
          <VStack gap={0} justifyContent="center" alignItems="start">
            <PortableTitle
              as="div"
              css={{
                fontFamily: "heading",
                fontSize: "30px",
                fontWeight: "600",
                lineHeight: "126%",
                mb: 8,

                "& em": {
                  background:
                    style === "1"
                      ? "linear-gradient(270deg, #DAA6FB 0%, rgba(218, 166, 251, 0.00) 94.48%)"
                      : "linear-gradient(270deg, #FFB48A 0%, rgba(218, 166, 251, 0.00) 94.48%)",
                  borderRadius: "0 50px 50px 0",
                  lineHeight: "46px",
                  boxDecorationBreak: "clone",
                  px: "6px",
                  py: "1px",
                  mx: "-6px",
                },
              }}>
              {contentTitle}
            </PortableTitle>
            <styled.div
              css={{
                fontSize: "20px",
                lineHeight: "133%",
                fontWeight: "400",
                opacity: 0.8,

                "& em": {
                  fontWeight: "700",
                },
              }}>
              <PortableText value={body} />
            </styled.div>
          </VStack>
        </Grid>
      </Container>
    </styled.div>
  )
}

export default MediaText4
export type { Props as MediaText4Props }
